import React, { useEffect, useState, memo } from 'react';

import './LiquidEffect.css';

const StaticCask = ({ width, height, mask, percent }) => {

  return (
    <div
      className="liquid-effect-container"
      style={{
        width, height,
        WebkitMaskImage: `url(${mask})`,
        maskImage: `url(${mask})`,
        maskPosition: 'center center',
        WebkitMaskPosition: 'center center',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskSize: '100% 100%',
        WebkitMaskSize: '100% 100%',
      }}
    >
      <img src={mask} style={{ opacity: 0.3, width: '100%', height: '100%' }} />
      <div
        className='liquid-effect-container-child'
        style={{
          top: height * (1 - percent),
        }}
      />

      <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: height * percent, overflow: 'hidden' }}>
        <img
          src={mask}
          style={{
            opacity: 1, width: width, height: height, position: 'absolute',
            bottom: 0, left: 0, right: 0,
          }}
        />
      </div>
    </div>
  )
};

export default StaticCask;
